var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOnline
    ? _c(
        "div",
        { staticClass: "auth-holder-ui" },
        [
          _vm.activeAuth
            ? _c(_vm.activeAuth, {
                tag: "component",
                attrs: { "default-type-auth": _vm.typeAuth },
                on: {
                  "change-auth": _vm.setActiveAuth,
                  "hide-auth": _vm.hideAuth
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }